export { default } from './EtiquetesEspecial';
